module.exports = __webpack_public_path__ + "img/b.9eb22ca6.svg";